/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contracts_EmptyInputs */

const cs_contracts_empty = /** @type {(inputs: Contracts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné smlouvy.`)
};

const en_contracts_empty = /** @type {(inputs: Contracts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No contracts yet.`)
};

/**
* | output |
* | --- |
* | "No contracts yet." |
*
* @param {Contracts_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contracts_empty = /** @type {((inputs?: Contracts_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contracts_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contracts_empty(inputs)
	return cs_contracts_empty(inputs)
});